<template>
  <!-- <12-4>教育机构案件应者查看界面-->

  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("projectApplicationDetails") }}</div>

    <div class="main-box">
      <!--        第一行 案件名-->
      <div class="first-line-box">
        <p class="title-all-css">{{ $t("caseName") }}</p>
        <el-input v-model="jobName"></el-input>
      </div>
      <!-- 第二行 採用担当 採用人数-->
      <div class="two-line-box">
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("recruiter") }}</p>
          <el-dropdown :disabled="disabled" @command="handleCommandPrincipal">
            <span class="el-long-dropdown-link">
              {{ this.principal
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in principalTableDate"
                :key="item.code"
                :command="item"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="normal-line-box">
          <p class="title-all-css">{{ $t("numberOfHires") }}</p>
          <el-input v-model="recruitNumber"></el-input>
        </div>
      </div>
      <!-- 第三行 勤務内容 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="title-all-css">{{ $t("workContent") }}</p>
          <el-input v-model="workContent"></el-input>
        </div>
      </div>
      <div class="line-button-box">
        <el-button type="warning" @click="goDetail">
          {{ $t("jobDetail") }}
        </el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          :data="tableData"
          @row-click="qaq"
          style="width: 95%"
          height="410px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="resumeId"
            label="人材番号"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="name"
            label="氏名"
            width="110px"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              <img
                src="src/pages/educationalInstitutionsTalentApplicationList/assets/name-img.png"
                alt=""
                class="table-img-css"
              />
              <span style="margin-left: 10px">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------性別---------------------- -->
          <el-table-column prop="sex" label="性別">
            <template slot="header">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandDrop">
                <span class="el-dropdown-link">
                  {{ sexname }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">男性</el-dropdown-item>
                  <el-dropdown-item command="1">女性</el-dropdown-item>
                  <el-dropdown-item command="null">ALL</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.sex_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpsex_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------出生月日---------------------- -->
          <el-table-column
            prop="birth"
            width="150px"
            label="出生月日"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("birth") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                :show-overflow-tooltip="true"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ----------------------学歴---------------------- -->
          <el-table-column prop="education" label="学歴" width="100">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <el-dropdown @command="handleCommandeducation">
                <span class="el-dropdown-link">
                  {{ educations
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in educationTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item command="null">
                    ALL
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.education_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpeducation_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------専攻---------------------- -->
          <el-table-column prop="profession" label="専攻" width="120">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
          </el-table-column>
          <!-- ----------------------日本語 ---------------------- -->
          <el-table-column prop="japanese" label="日本語 " width="130px">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japaneseVs") }}</p>
              <el-dropdown @command="handleCommandjapaneseVs">
                <span class="el-dropdown-link">
                  {{ japaneseVs
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in japaneseVsTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item command="null">
                    ALL
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.japanese_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpjapanese_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------学校---------------------- -->
          <el-table-column prop="school" label="学校" width="170px">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("school") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
          </el-table-column>
          <!-- ----------------------応募日---------------------- -->
          <el-table-column
            prop="createTime"
            label="応募日"
            :min-width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("fundingDayPayment") }}</p>
              <el-input
                v-model="searchData8"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
          </el-table-column>
          <!-- ----------------------状態---------------------- -->
          <el-table-column prop="statusName" label="状態" width="90">
            <template slot="header">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandstatus">
                <span class="el-dropdown-link">
                  {{ statusnames
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in statusTableData"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item command="null">
                    ALL
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.statusName_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpstatusName_dictText }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="total"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getJobByApplication,
  getResumeByApplication,
  queryApplyResumeInfo,
  fuzzyResumeByJobId,
  queryResumeByJobId
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "educationInstitutionCasesToViewInterface",
  components: {},
  data() {
    return {
      tableData: [],
      total: 0,
      jobName: "", //案件名input
      recruitNumber: "", //採用人数input
      workContent: "", //勤務内容input
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      infoData: [], //案件信息
      principal: "", //担当
      opPrincipal: "",
      disabled: false, //禁用状态
      principalTableDate: [],
      jobId: "",
      jobIdS: "",
      sexname: "ALL",
      sex: "",
      language: "",
      statusTableData: "",
      statusname: "",
      statusnames: "ALL",
      japaneseVsTableData: "",
      japaneseV: "",
      japaneseVs: "ALL",
      educationTableData: "",
      education: "",
      educations: "ALL"
    };
  },
  created() {
    this.language = window.localStorage.getItem("language");
    console.log(668888, this.$route.query);
    this.jobIdS = this.$route.query.jobId;
    this.getJobByApplication();
    //this.getResumeByApplication();
    this.principalCount();
    //下拉获取
    this.statusRights();
    this.japaneseVsRights();
    this.educationRights();
    this.educationRights();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    goDetail() {
      this.$router.push({
        path: "/educationViewJobInformation",
        query: { id: this.jobIdS }
      });
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.statusRights();
        this.japaneseVsRights();
        this.FuzzyQuery();
      }
    },
    //获取下拉框选项

    educationRights() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpeducation";
      } else {
        dataItems = "education";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationTableData = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    japaneseVsRights() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpjapanese";
      } else {
        dataItems = "japanese";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.japaneseVsTableData = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    statusRights() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpstatusName";
      } else {
        dataItems = "statusName";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.statusTableData = aesFecInfo.data;
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    qaq(row, event, column) {
      // row.applyId = this.$route.query.applyId;
      row.jobId = this.jobId;
      row.jobName = this.jobName;
      this.$router.push({
        name: "detailsOfApplicantsForCasesInEducationalInstitutions",
        query: {
          row: JSON.stringify(row)
        }
      });
      console.log(row);
    },
    //模糊查询
    FuzzyQuery() {
      var fakeInfo = {
        birthEnd: "",
        birthStart: "",
        createTimeEnd: "",
        createTimeStart: this.searchData8,
        education: this.education,
        japanese: this.japaneseV,
        jobId: this.jobId,
        name: this.name,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        profession: this.searchData5,
        resumeId: this.searchData1,
        school: this.searchData7,
        sex: this.sex,
        applyStatus: this.statusname
      };
      fuzzyResumeByJobId(fakeInfo)
        .then(res => {
          console.log("-----模糊查询当前教育机构应聘信息的用户-----");
          console.log(fakeInfo);
          console.log(res);
          if (res.data.code == "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.total = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
    },
    //担当着下拉框获取
    principalCount() {
      console.log("下拉获取");
      var that = this;
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: "principal"
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.principalTableDate = aesFecInfo.data;
            console.log("-----------");
            console.log(that.principalTableDate);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommandPrincipal(e) {
      this.inputData9 = e.code;
      this.opPrincipal = e.name;
      console.log(e);
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "numberCases") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberCases"] - b["numberCases"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberCases"] - a["numberCases"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberViewings"] - b["numberViewings"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberViewings"] - a["numberViewings"]
          );
        }
      }
    },
    //复选框
    handleSelectionChange(val) {
      console.log(val);
      console.log("选择了" + val.length + "项数据");
    },
    //下拉框
    handleCommandDrop(val) {
      if (val == "null") {
        this.sexname = "ALL";
        this.sex = "";
      } else {
        if (val == "0") {
          this.sexname = "男性";
          this.sex = "0";
        } else {
          this.sexname = "女性";
          this.sex = "1";
        }
      }
      this.FuzzyQuery();
    },
    //分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getQueryApplyResumeInfo();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log("7");
      } else if (command === "b") {
        this.pageSize = 15;
        console.log("15");
      } else if (command === "c") {
        this.pageSize = 20;
        console.log("20");
      } else if (command === "d") {
        this.pageSize = 25;
        console.log("25");
      }
      this.currentPage = 1;
      this.getQueryApplyResumeInfo();
    },
    //接口 查询
    getJobByApplication() {
      console.log("--------传参查询--------");
      console.log(this.$route.query.applyId);
      var applyJobStatusDTO = {
        applyId: this.$route.query.applyId
      };
      getJobByApplication(applyJobStatusDTO)
        .then(res => {
          console.log("--------应聘信息获取当前案件信息接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.recruitNumber = aesFecInfo.data[0].recruitNumber;
            this.principal = aesFecInfo.data[0].userName;
            this.jobName = aesFecInfo.data[0].jobName;
            this.workContent = aesFecInfo.data[0].workContent;
            this.jobId = aesFecInfo.data[0].jobId;
            this.getQueryApplyResumeInfo(); //下面信息查询接口
          }
        })
        .catch(res => {
          console.log("应聘信息获取当前案件信息接口异常:", res);
        });
    },
    //下面查询
    getQueryApplyResumeInfo() {
      var fakeInfo = {
        jobId: this.jobId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      console.log(fakeInfo);
      queryResumeByJobId(fakeInfo)
        .then(res => {
          console.log("--------有应聘信息的用户aaa--------");
          console.log(fakeInfo);
          console.log(this.jobid);
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.total = aesFecInfo.total;
          }
        })
        .catch(res => {
          console.log("人才列表接口异常:", res);
        });
    },

    //状态下拉
    handleCommandstatus(e) {
      if (e == "null") {
        this.statusname = "";
        this.statusnames = "ALL";
      } else {
        this.statusname = e.code;
        this.statusnames = e.name;
      }
      this.FuzzyQuery();
    },
    handleCommandjapaneseVs(e) {
      if (e == "null") {
        this.japaneseV = "";
        this.japaneseVs = "ALL";
      } else {
        this.japaneseV = e.code;
        this.japaneseVs = e.name;
      }
      this.FuzzyQuery();
    },
    handleCommandeducation(e) {
      if (e == "null") {
        this.education = "";
        this.educations = "ALL";
      } else {
        this.education = e.code;
        this.educations = e.name;
      }
      this.FuzzyQuery();
    }
  }
};
</script>
<style scoped>
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.main-css {
  width: 100%;
  height: 100%;
}
.main-box {
  margin-top: 0px;
  width: 100%;
  height: 0;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  height: 420px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}
.table /deep/ .el-dropdown {
  width: 60px;
}
.main-box /deep/ .el-input__inner {
  border: 1px solid transparent;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}
.table-img-css {
  border-radius: 50%;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 8px;
}
.pagination-main {
  float: right;
  margin-right: 100px;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.first-line-box {
  width: 640px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 5px;
  position: relative;
}
.two-line-box {
  width: 640px;
  height: 48px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.normal-line-box {
  width: 300px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.title-all-css {
  padding: 0 5px;
  background: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  position: absolute;
  top: -12px;
  left: 10px;
  z-index: 10;
}
.big-line-box {
  height: 79px;
  width: 640px;
  margin: 0 auto;
  margin-top: 15px;
}
.big-box-css {
  height: 79px;
  width: 640px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.line-box /deep/ .el-dropdown {
  width: 299px;
  height: 44px;
  line-height: 44px;
  padding-left: 10px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #b2b2b2;
  box-sizing: border-box;
}
.line-box /deep/ .el-dropdown-link {
  width: 280px;
  display: inline-block;
}
.line-box /deep/ .el-icon-arrow-down {
  line-height: 44px;
  float: right;
}
.two-line-box /deep/ .el-icon--right {
  margin-left: 260px;
  font-size: 20px;
  line-height: 45px;
}
.big-box-css /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0 10px;
  color: #09101d;
}
.big-box-css /deep/ .el-input {
  width: 99%;
  height: 42px;
  margin-left: 2px;
}
.el-long-dropdown-link {
  width: 620px;
  display: inline-block;
  padding: 0 0 0 15px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationInstitutionCaseResponderViewing/index.vue